import { render, staticRenderFns } from "./MoveSubjectSnackbar.vue?vue&type=template&id=52b88056"
import script from "./MoveSubjectSnackbar.ts?vue&type=script&lang=ts&external"
export * from "./MoveSubjectSnackbar.ts?vue&type=script&lang=ts&external"
import style0 from "./MoveSubjectSnackbar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports